import { doPrivatePostRequest, doPrivateGetRequest } from "./requests"

export const createMeet = (_data, _token) => {
    const path = '/meets/create'
    return doPrivatePostRequest(_data, path, _token)
}

export const createMeetQuick = (_data, _token) => {
    const path = '/meets/create/quick'
    const data = {
        'title': _data['title'],
        'start_time': _data['start_time'],
        'end_time': _data['end_time']
    }
    return doPrivatePostRequest(data, path, _token)
}

export const updateMeet = (_data, _token) => {
    const path = '/meets/update'
    return doPrivatePostRequest(_data, path, _token)
}

export const getMyMeetsToday = (_token) => {
    const path = '/meets/get'
    const params = {
        'st': 'BY-TODAY',
        'sk': 'current',
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getMyMeetsUpComing = (_token) => {
    const path = '/meets/get'
    const params = {
        'st': 'BY-UPCOMING',
        'sk': 'current',
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getMyMeetsPast = (_token) => {
    const path = '/meets/get'
    const params = {
        'st': 'BY-PAST',
        'sk': 'current',
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getByDocId = (_doc_id, _token) => {
    const path = '/meets/get'
    const params = {
        'st': 'DOC-ID',
        'sk': _doc_id,
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getByShortCode = (_short_code, _token) => {
    const path = '/meets/get'
    const params = {
        'st': 'SHORT-CODE',
        'sk': _short_code,
    }
    return doPrivatePostRequest(params, path, _token)
}

export const setMeetsStartTime = (_meets_id, _token) => {
    const path = `/meets/set-start-time/${_meets_id}`
    return doPrivateGetRequest(path, _token)
}